import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import MobileAppointmentForm from './MobileAppointmentForm'

export default function MobileCreateAppointmentPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <>
      <PublicSiderXS />
      <MobileAppointmentForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
    </>
  )
}
